import React, { Component } from "react";
import {
    NavBar,
    BreadCumb,
    TimeOut,
    SuggestionsList,
    StandardSelectModal,
    PdfViewer
} from "../../components";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";
import config from "../../config";
import moment from "moment";
import ApiClient from "../../libs/apiClient";
import $ from "jquery";
import { CSVLink } from "react-csv";
const apiClient = ApiClient.getInstance();

const paginate = (array = [], pageNumber = 1, pageSize = 10) => { return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize) }

const date = (date = "") => {
    return moment(date).format("DD/MM/YYYY");
}

const docStatus = (status = "O", doc = {}) => {
    if (doc.CANCELED === "Y") return <><i className="fa fa-ban mr-2" /> Cancelado </>;

    switch (status) {
        case "O": return <><i className="fa fa-unlock mr-2" /> Abierto </>;
        case "C": return <><i className="fa fa-lock mr-2" /> Cerrado </>;
        default: return <><i className="fa fa-unlock mr-2" /> Abierto </>;
    }
}

const formatNumber = (num = "0") => {
    num = Number(num).toFixed(2);
    const separador = ','; // separador para los miles
    const sepDecimal = '.'; // separador para los decimales

    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    let regex = /(\d+)(\d{3})/;

    while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
    return splitLeft + splitRight;
};

const folio = (NumAtCard = "") => {
    if (!NumAtCard) return "SIN FOLIO";
    if (NumAtCard.trim() === "") return "SIN FOLIO";
    return NumAtCard;
}

const AcctCodes = (acctCode = "", doc = {}) => {
    if (!doc) return "";
    return (
        <>
            {!!doc.CashAcct && doc.CashAcct !== "" &&
                <>
                    <span className="font-weight-bold"> Efectivo </span> <br />
                    <span> {doc.CashAcct} </span> <br />
                </>
            }

            {!!doc.TrsfrAcct && doc.TrsfrAcct !== "" &&
                <>
                    <span className="font-weight-bold"> Transferencias </span> <br />
                    <span> {doc.TrsfrAcct} </span> <br />
                </>
            }

            {!!doc.CreditAcct && doc.CreditAcct !== "" &&
                <>
                    <span className="font-weight-bold"> Tarjetas </span> <br />
                    <span className="text-left"> {doc.CreditAcct.split("|").map(AcctCode => <><span>{AcctCode}</span><br /></>)} </span> <br />
                </>
            }

            {!!doc.CheckAcct && doc.CheckAcct !== "" &&
                <>
                    <span className="font-weight-bold"> Cheques </span> <br />
                    <span> {doc.CheckAcct} </span> <br />
                </>
            }
        </>
    );
}

const createBy = (creator = "", doc = {}) => {
    if (!doc) return "SAP";
    if (doc.U_SO1_01RETAILONE === "Y") return "RETAIL ONE";
    switch (Number(doc.U_FMB_CREATEBY || "0")) {
        case 0: return "SAP";
        case 1: return "BRANCH";
        case 2: return "COUNTER";
        case 3: return "HANDEL";
        case 4: return "M-VENTAS";
        case 5: return "M-ENTREGAS";
        case 6: return "SAP-CEDIS";
        default: return "SAP";
    }
}

const headers = {
    default: [
        { key: "DocNum", label: "N° Doc", title: "N° Doc", field: "DocNum", active: true, filter: true, format: null, classes: "text-center" },
        { key: "NumAtCard", label: "Folio", title: "Folio", field: "NumAtCard", active: true, filter: true, format: folio, classes: "text-center" },
        { key: "SeriesName", label: "Serie", title: "Serie", field: "SeriesName", active: true, filter: true, format: null, classes: "text-center" },
        { key: "U_FMB_CREATEBY", label: "Creado desde", title: "Creado desde", field: "U_FMB_CREATEBY", active: true, filter: false, format: createBy, classes: "text-center" },
        { key: "DocDate", label: "Fecha", title: "Fecha", field: "DocDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "DocStatus", label: "Estatus", title: "Estatus", field: "DocStatus", active: true, filter: false, format: docStatus, classes: "text-center" },
        { key: "DocTotal", label: "Total", title: "Total", field: "DocTotal", active: true, filter: false, format: formatNumber, classes: "text-center" },
    ],
    OQUT: [
        { key: "DocNum", label: "N° Doc", title: "N° Doc", field: "DocNum", active: true, filter: true, format: null, classes: "text-center" },
        { key: "NumAtCard", label: "Folio", title: "Folio", field: "NumAtCard", active: true, filter: true, format: folio, classes: "text-center" },
        { key: "SeriesName", label: "Serie", title: "Serie", field: "SeriesName", active: true, filter: true, format: null, classes: "text-center" },
        { key: "U_FMB_CREATEBY", label: "Creado desde", title: "Creado desde", field: "U_FMB_CREATEBY", active: true, filter: false, format: createBy, classes: "text-center" },
        { key: "DocDate", label: "Fecha", title: "Fecha", field: "DocDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "DocStatus", label: "Estatus", title: "Estatus", field: "DocStatus", active: true, filter: false, format: docStatus, classes: "text-center" },
        { key: "DocTotal", label: "Total", title: "Total", field: "DocTotal", active: true, filter: false, format: formatNumber, classes: "text-right" },
    ],
    ORDR: [
        { key: "DocNum", label: "N° Doc", title: "N° Doc", field: "DocNum", active: true, filter: true, format: null, classes: "text-center" },
        { key: "NumAtCard", label: "Folio", title: "Folio", field: "NumAtCard", active: true, filter: true, format: folio, classes: "text-center" },
        { key: "SeriesName", label: "Serie", title: "Serie", field: "SeriesName", active: true, filter: true, format: null, classes: "text-center" },
        { key: "U_FMB_CREATEBY", label: "Creado desde", title: "Creado desde", field: "U_FMB_CREATEBY", active: true, filter: false, format: createBy, classes: "text-center" },
        { key: "DocDate", label: "Fecha", title: "Fecha", field: "DocDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "DocStatus", label: "Estatus", title: "Estatus", field: "DocStatus", active: true, filter: false, format: docStatus, classes: "text-center" },
        { key: "Quantity", label: "Cantidad", title: "Unidades pedidas", field: "Quantity", active: true, filter: false, format: formatNumber, classes: "text-right" },
        { key: "DeliveryQty", label: "Unidades surtidas", title: "Unidades surtidas", field: "DeliveryQty", active: true, filter: false, format: formatNumber, classes: "text-right" },
        { key: "OpenQty", label: "Unidades restantes ", title: "Unidades restantes", field: "OpenQty", active: true, filter: false, format: formatNumber, classes: "text-right" },
        { key: "DocTotal", label: "Total", title: "Total", field: "DocTotal", active: true, filter: false, format: formatNumber, classes: "text-right" },
    ],
    ODLN: [
        { key: "DocNum", label: "N° Doc", title: "N° Doc", field: "DocNum", active: true, filter: true, format: null, classes: "text-center" },
        { key: "NumAtCard", label: "Folio", title: "Folio", field: "NumAtCard", active: true, filter: true, format: folio, classes: "text-center" },
        { key: "SeriesName", label: "Serie", title: "Serie", field: "SeriesName", active: true, filter: true, format: null, classes: "text-center" },
        { key: "U_FMB_CREATEBY", label: "Creado desde", title: "Creado desde", field: "U_FMB_CREATEBY", active: true, filter: false, format: createBy, classes: "text-center" },
        { key: "DocDate", label: "Fecha", title: "Fecha", field: "DocDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "DocStatus", label: "Estatus", title: "Estatus", field: "DocStatus", active: true, filter: false, format: docStatus, classes: "text-center" },
        { key: "DocTotal", label: "Total", title: "Total", field: "DocTotal", active: true, filter: false, format: formatNumber, classes: "text-right" },
    ],
    OINV: [
        { key: "DocNum", label: "N° Doc", title: "N° Doc", field: "DocNum", active: true, filter: true, format: null, classes: "text-center" },
        { key: "NumAtCard", label: "Folio", title: "Folio", field: "NumAtCard", active: true, filter: true, format: folio, classes: "text-center" },
        { key: "SeriesName", label: "Serie", title: "Serie", field: "SeriesName", active: true, filter: true, format: null, classes: "text-center" },
        { key: "U_FMB_CREATEBY", label: "Creado desde", title: "Creado desde", field: "U_FMB_CREATEBY", active: true, filter: false, format: createBy, classes: "text-center" },
        { key: "DocDate", label: "Fecha", title: "Fecha de contabilización", field: "DocDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "DocDueDate", label: "Fecha de vencimiento", title: "Fecha de vencimiento", field: "DocDueDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "DueDays", label: "Días vencidos", title: "Días vencidos", field: "DueDays", active: true, filter: false, format: null, classes: "text-right" },
        { key: "DocStatus", label: "Total", title: "Estatus", field: "DocStatus", active: true, filter: false, format: docStatus, classes: "text-center" },
        { key: "DocTotal", label: "Total", title: "Total", field: "DocTotal", active: true, filter: false, format: formatNumber, classes: "text-right" },
        { key: "PaidToDate", label: "Abonado", title: "Abonado", field: "PaidToDate", active: true, filter: false, format: formatNumber, classes: "text-right" },
        { key: "DueTotal", label: "Restante", title: "Restante", field: "DueTotal", active: true, filter: false, format: formatNumber, classes: "text-right" },
    ],
    ORCT: [
        { key: "DocNum", label: "N° Doc", title: "N° Doc", field: "DocNum", active: true, filter: true, format: null, classes: "text-center" },
        { key: "NumAtCard", label: "Folio", title: "Folio", field: "NumAtCard", active: true, filter: true, format: folio, classes: "text-center" },
        { key: "SeriesName", label: "Serie", title: "Serie", field: "SeriesName", active: true, filter: true, format: null, classes: "text-center" },
        { key: "U_FMB_CREATEBY", label: "Creado desde", title: "Creado desde", field: "U_FMB_CREATEBY", active: true, filter: false, format: createBy, classes: "text-center" },
        { key: "DocDate", label: "Fecha", title: "Fecha", field: "DocDate", active: true, filter: false, format: date, classes: "text-center" },
        { key: "CashAcct", label: "N° Cuenta", title: "N° Cuenta", field: "CashAcct", active: true, filter: false, format: AcctCodes, classes: "text-center" },
        { key: "DocTotal", label: "Abono", title: "Abono", field: "DocTotal", active: true, filter: false, format: formatNumber, classes: "text-right" },
        { key: "Ref", label: "Referencia", title: "Referencia", field: "Ref", active: true, filter: false, format: null, classes: "text-center" },
    ]
};

class PartnerDocumentsView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            data: [],
            processedData: [],

            filters: {
                cardCode: "---",
                cardName: "",
                table: "-",
                subtable: "-",
                dateStart: moment().format("YYYY-MM-DD"),
                dateEnd: moment().format("YYYY-MM-DD"),
                invoiceStatus: "---",
            },

            suggestionCatalogs: {
                businessPartnerCCatalog: [],
            },

            showSelectBPModal: false,
            showBPSuggestion: false,
            businessParterSuggestions: [],

            tableNav: {
                pageNumber: 1,
                pageSize: 10,
                firstPage: false,
                previousPage: false,
                nextPage: false,
                lastPage: false,
            },

            selectedAll: false,
            selectionList: [],

            showPDFViewer: false,
            docsToPrint: [],
            printhide: true,

            sendMailModel: {
                to: '',
                subject: '',
            },
        }

        this.headers = headers.default;
        this.cardNameInput = React.createRef();
    }

    componentDidMount = async () => {
        // await this.getSuggestionCatalogs();
    }

    //#region Get Data
    getSuggestionCatalogs = async (value = '') => {
        let suggestionCatalogsResposne = await apiClient.getSuggestionCatalogs({ businessPartnerC: true, searchPartnerValue: value });
        suggestionCatalogsResposne = suggestionCatalogsResposne.data;

        if (!!suggestionCatalogsResposne) {
            let suggestionCatalogs = {
                businessPartnerCCatalog: suggestionCatalogsResposne.businessPartnerC,
            };

            await this.setState({ suggestionCatalogs });
        }
    }

    searchDocuments = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { filters } = this.state;
        this.setState({ data: [], processedData: [] });

        if (filters.cardCode === "---") { return showAlert({ type: "warning", message: "Selecciona un cliente valido por favor" }); }
        if (filters.table === "-" || filters.table === "-") { return showAlert({ type: "warning", message: "Selecciona un tipo de documento valido por favor" }); }
        if (!moment(filters.dateStart, 'YYYY-MM-DD', true).isValid()) { return showAlert({ type: "warning", message: "Ingresa un rango de fechas valido por favor" }); }
        if (!moment(filters.dateEnd, 'YYYY-MM-DD', true).isValid()) { return showAlert({ type: "warning", message: "Ingresa un rango de fechas valido por favor" }); }

        const data = {
            ...filters,
            dateStart: moment(filters.dateStart).format("YYYYMMDD"),
            dateEnd: moment(filters.dateEnd).format("YYYYMMDD"),
        };

        enableSpinner(true);
        const documentsResponse = await apiClient.GetPartnerDocumentsList(data);
        enableSpinner(false);

        if (documentsResponse.status !== SERVICE_RESPONSE.SUCCESS) {
            return showAlert({ type: "info", message: documentsResponse.message || "ocurrio un error inesperado al consultar los documentos" });
        }

        await this.setState({ data: documentsResponse.data });
        await this.searchInTable();
        $("html, body").animate({ scrollTop: $("#dataTableDocuments").offset().top }, 1000);
    }
    //#endregion

    //#region Open Selection Modals
    openBusinessPartnerModal = async () => {
        await this.setState({ showSelectBPModal: true });
        $("#selectBPModal").modal("show");
        $("#selectBPModal").on("hidden.bs.modal", async () => {
            await this.setState({ showSelectBPModal: false });
        });
    }
    //#endregion

    //#region update filters
    changeFilter = (filter = "", value = "") => {
        let { filters } = this.state;
        filters[filter] = value;
        this.setState({ filters });
        if (filter === "invoiceStatus") { this.searchInTable(); }
    }

    changeCardName = async (value) => {
        const { filters } = this.state;

        filters.cardCode = "---";
        filters.cardName = value;

        this.setState({ filters });
        await this.getSuggestionCatalogs(value);
        this.SearchPartnersSuggestions(value);
    }

    SearchPartnersSuggestions = (value) => {
        const { suggestionCatalogs: { businessPartnerCCatalog } } = this.state;


        let businessParterSuggestions = [];

        if (value.trim() !== "") {
            const searchTokens = value.toLowerCase().split(" ");
            businessParterSuggestions = businessPartnerCCatalog.filter(record => {
                const tokens = (record?.CardCode + " " + record?.CardName + " " + record?.LicTradNum).toLowerCase().split(" ");
                return searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token))
                )
            }).slice(0, 15);
        }

        const showBPSuggestion = businessParterSuggestions.length > 0;
        this.setState({ businessParterSuggestions, showBPSuggestion });

    }

    searchBP = async(value = "") => {
        const { suggestionCatalogs: { businessPartnerCCatalog }, filters } = this.state;
        if (value.trim() === "") return;
        await this.changeCardName(value)

        const businessPartner = businessPartnerCCatalog.find(({ CardCode, CardName, LicTradNum }) => CardCode === value || CardName === value || LicTradNum === value);
        if (businessPartner) {
            filters.cardCode = businessPartner.CardCode;
            filters.cardName = businessPartner.CardName;
        } else {
            this.openBusinessPartnerModal();
        }
        this.setState({ filters, businessParterSuggestions: [], showBPSuggestion: false });
        $("#selectBPModal").modal("hide");
    }

    selectBP = (businessPartner) => {
        let { filters } = this.state;
        filters.cardCode = businessPartner.CardCode;
        filters.cardName = businessPartner.CardName;
        this.setState({ filters, businessParterSuggestions: [], showBPSuggestion: false });
        $("#selectBPModal").modal("hide");
    }

    changeTable = (value = "---") => {
        const { notificationReducer: { showAlert } } = this.props;
        let { filters } = this.state;

        if (value !== "---") {
            const tableData = value.split("-");
            if (!tableData[1]) { return showAlert({ type: "warning", message: "Ocurrio un error al cargar los datos, por favor recargue la página" }); }

            filters.table = tableData[0];
            filters.subtable = tableData[1];
            this.headers = headers[tableData[0]] || headers.default;
            this.searchDocuments();
        } else {
            filters.table = "-";
            filters.subtable = "-";
            filters.invoiceStatus = "---";
            this.setState({ data: [], processedData: [] });
        }
        this.setState({ filters, selectedAll: false, selectionList: [] });
    }
    //#endregion

    //#region DataTable Actions

    searchInTable = async (value = "") => {
        const { data, filters } = this.state;
        const columnsToFilter = this.headers.filter(({ filter }) => filter) || [];
        let searchResult = data;
        if (filters.invoiceStatus === "0") { searchResult = data.filter(({ DueTotal, DueDays }) => Number(DueTotal) > 0 && Number(DueDays) < 0); }
        else if (filters.invoiceStatus === "1") { searchResult = data.filter(({ DueTotal, DueDays }) => Number(DueTotal) > 0 && Number(DueDays) >= 0); }

        if (value.trim() !== "") {
            let searchTokens = value.toLowerCase().split(" ");
            searchResult = await data.filter(record => {
                const formattedRow = columnsToFilter.map(({ field }) => record[field]).join(" ");
                let tokens = formattedRow.toLowerCase().split(" ");
                return searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token)));
            });
        }

        await this.setState({ searchBar: value, processedData: searchResult, selectedAll: false, selectionList: [] });
        this.first();
    }

    SendToPrint = async () => {
        const { selectionList, data, filters } = this.state;
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (selectionList.length === 0) { return showAlert({ type: "error", message: "Selecciona algún documento para imprimir" }); }
        if (selectionList.length > 20) { return showAlert({ type: "error", message: "Por el momento solo se pueden imprimir 20 documentos a la vez" }); }

        let docsToPrintIds = [];
        for (const docEntry of selectionList) {
            const doc = data.find(({ DocEntry }) => DocEntry === docEntry);
            let hasCounterFolio = true;
            if (!doc) { hasCounterFolio = false; }
            else {
                hasCounterFolio = !(doc.U_SO1_01RETAILONE === "Y" || Number(doc.U_FMB_CREATEBY) !== 2);
                if (hasCounterFolio) {
                    hasCounterFolio = !(!doc.NumAtCard || doc.NumAtCard === "" || doc.NumAtCard === "SIN FOLIO")
                }
            }
            docsToPrintIds.push(hasCounterFolio ? doc.NumAtCard : `-----${docEntry}`);
        }

        let typeDoc = 0;
        switch (filters.table) {
            case "OQUT": typeDoc = 23; break;
            case "ORDR": typeDoc = 17; break;
            case "ODLN": typeDoc = 15; break;
            case "OINV": typeDoc = 13; break;
            case "ORCT": typeDoc = 24; break;
            default: typeDoc = 0; break;

        }

        const printData = { docsToPrintIds, typeDoc }
        enableSpinner(true);
        let responseApi = [];

        if (typeDoc === 24) {
            let collection = [];
            let flag = false;
            for (const folio of docsToPrintIds) {
                let info = {
                    doc: folio.substring(5, 50),
                    table: 'ORCT',
                    docSubType: "--",
                    view: "payment",
                    view2: "payment"
                };
                responseApi = await apiClient.getDocumentsDetails(info);
                if (responseApi.status === 1) {
                    flag = true;
                    responseApi.data.header.folio = folio;
                    collection.push(responseApi.data);
                }
            }
            if (flag) { responseApi.data = collection; }
        } else { responseApi = await apiClient.getPrintDocsInfo(printData); }
        enableSpinner(false);

        if (responseApi.status !== 1) { return showAlert({ type: "error", message: `${responseApi.message}` }); }

        await this.setState({
            showPDFViewer: true,
            docsToPrint: responseApi.data || [],
        });
        $("#pdfViewer").modal("show");
        $("#selectBPModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showPDFViewer: false,
                docsToPrint: [],
            });
        });
    }

    ShowFormatToPrint = async () => {
        await this.setState({ printhide: !this.state.printhide, });
    }

    //#region ########## Mail Functions #####################################################
    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    }

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDoc } = this.state;
        let infoDoc = [];

        for (const document of docsToPrint) {
            let newInfoDoc = {
                cardCode: document.docHeader ? document.docHeader.responseHeader.CardCode : document.header.CardCode || '',
                folio: document.docHeader ? (document.docHeader.infoByFolio.folio || document.docHeader.responseHeader.infoByFolio.folio) : document.header.folio || '',
                docEntry: document.docHeader ? document.docHeader.responseHeader.DocEntry : document.header.DocEntry || '',
                slpInfo: {
                    slpCode: document.docHeader ? document.docHeader.responseHeader.SlpCode : document.header.SlpCode || '',
                    slpName: document.docHeader ? document.docHeader.responseHeader.SlpName : document.header.SlpName || '',
                }
            }
            infoDoc.push(newInfoDoc);
        }

        let mailData = {
            sendMailModel,
            typeDoc,
            infoDoc
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(mailData);
        enableSpinner(false);

        if (responseApi.status !== 1) { return showAlert({ type: "error", message: `${responseApi.message ?? ''}` }); }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }
    //#endregion

    //#region Selección multiple
    selectAllAction = async (currentElements = [], clean = false) => {
        let selectionList = [];
        let selectedAll = !this.state.selectedAll;
        if (clean) { selectedAll = false; }

        if (selectedAll) {
            for (let i = 0; i < currentElements.length; i++) {
                const currentElement = currentElements[i];
                selectionList.push(currentElement.DocEntry);
            }
        }

        await this.setState({ selectedAll, selectionList });
    };

    selectOneAction = async (currentElement, currentElements = []) => {
        let selectionList = this.state.selectionList.slice();
        let selectedAll = false;

        if (!selectionList.find(element => element === currentElement)) {
            selectionList.push(currentElement);
            if (selectionList.length === currentElements.length) { selectedAll = true; }
        } else { selectionList = selectionList.filter(element => element !== currentElement); }

        await this.setState({ selectedAll, selectionList });
    };
    //#endregion

    //#region Navigation
    first = () => {
        const { pageSize, processedData } = this.state;
        const totalPage = processedData.length;

        this.setState({
            tableNav: {
                ...this.state.tableNav,
                pageNumber: 1,
                firstPage: false,
                previousPage: false,
                nextPage: Number(totalPage || 0) / Number(pageSize || 10) > 1,
                lastPage: Number(totalPage || 0) / Number(pageSize || 10) > 1,
            }
        });
    }

    previous = () => {
        const pageNumber = Number(this.state.tableNav.pageNumber) - 1;

        this.setState({
            tableNav: {
                ...this.state.tableNav,
                pageNumber: pageNumber,
                firstPage: pageNumber > 1,
                previousPage: pageNumber > 1,
                nextPage: true,
                lastPage: true,
            }
        });
    }

    next = () => {
        const { pageSize, processedData } = this.state;
        const totalPage = processedData.length;

        let last = Math.ceil(Number(totalPage || 0) / Number(pageSize || 10));
        const pageNumber = Number(this.state.tableNav.pageNumber) + 1;

        this.setState({
            tableNav: {
                ...this.state.tableNav,
                pageNumber: pageNumber,
                firstPage: true,
                previousPage: true,
                nextPage: pageNumber < last,
                lastPage: pageNumber < last,
            }
        });
    }

    last = () => {
        const { pageSize, processedData } = this.state;
        const totalPage = processedData.length;

        let last = Math.ceil(Number(totalPage || 0) / Number(pageSize || 10));
        this.setState({
            tableNav: {
                ...this.state.tableNav,
                pageNumber: last,
                firstPage: true,
                previousPage: true,
                nextPage: false,
                lastPage: false,
            }
        });
    }
    //#endregion

    //#endregion

    //#region render
    renderFilters() {
        const {
            filters: {
                cardCode,
                cardName,
                table,
                subtable,
                dateStart,
                dateEnd,
                invoiceStatus,
            },
        } = this.state;

        return (
            <div className="row ml-0 m-sm-3">
                <div className="col-12 col-md-6 col-xl-3">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <label className="input-group-text font-weight-bold" htmlFor="txtCardName">Cliente</label>
                        </div>
                        <input
                            ref={this.cardNameInput}

                            id="txtCardName"
                            className="form-control"
                            type="text"
                            autoComplete="off"

                            value={cardName}
                            onChange={({ target: { value } }) => this.changeCardName(value)}
                            onBlur={() => this.setState({ businessParterSuggestions: [], showBPSuggestion: false })}
                            onKeyDown={({ key }) => {
                                if (key === "Enter") {
                                    if (cardCode === "---") { this.searchBP(cardName); }
                                    else { this.searchDocuments(); }
                                }
                            }} />

                        <div className="input-group-append">
                            <button type="button" className="btn btn-outline-warning" onClick={() => this.openBusinessPartnerModal()}> <i className="fa fa-list" /> </button>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-2">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend"> <label className="input-group-text font-weight-bold" htmlFor="selectTable">Documento</label> </div>
                        <select
                            id="selectTable"
                            className="form-control"
                            value={`${table}-${subtable}`}
                            onChange={({ target: { value } }) => this.changeTable(value)} >
                            <option value="---"> Seleccionar </option>
                            <option value="OQUT-QUT1"> Oferta de venta </option>
                            <option value="ORDR-RDR1"> Ordenes </option>
                            <option value="ODLN-DLN1"> Entregas </option>
                            <option value="OINV-INV1"> Facturas </option>
                            <option value="ORCT-RCT1"> Cobranza </option>
                        </select>
                    </div>
                </div>

                <div className="col-12 col-sm-6 col-lg-3 col-xl-2">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend"> <label className="input-group-text font-weight-bold" htmlFor="txtDateStart">Desde</label> </div>
                        <input
                            id="txtDateStart"
                            className="form-control"
                            type="date"
                            value={dateStart}
                            onChange={({ target: { value } }) => this.changeFilter("dateStart", value)}
                            onKeyDown={({ key }) => { if (key === "Enter") { this.searchDocuments(); } }} />
                    </div>
                </div>

                <div className="col-12 col-sm-6 col-lg-3 col-xl-2">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend"> <label className="input-group-text font-weight-bold" htmlFor="txtDateEnd">Hasta</label> </div>
                        <input
                            id="txtDateEnd"
                            className="form-control"
                            type="date"

                            value={dateEnd}
                            onChange={({ target: { value } }) => this.changeFilter("dateEnd", value)}
                            onKeyDown={({ key }) => { if (key === "Enter") { this.searchDocuments(); } }} />
                    </div>
                </div>

                {table === "OINV" &&
                    <div className="col-8 col-sm-6 col-lg-3 col-xl-2 fade-in">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend"> <label className="input-group-text font-weight-bold" htmlFor="selectInvStatus">Estatus</label> </div>
                            <select
                                id="selectInvStatus"
                                className="form-control"
                                value={invoiceStatus}
                                onChange={({ target: { value } }) => this.changeFilter("invoiceStatus", value)} >
                                <option value="---"> Todos </option>
                                <option value="0"> Vigentes </option>
                                <option value="1"> Vencidas </option>
                            </select>
                        </div>
                    </div>
                }

                <div className="col-4 col-sm-6 col-lg-3 col-xl-1">
                    <div className="input-group mb-3">
                        <button className="btn btn-dark" style={{ whiteSpace: "nowrap" }} onClick={this.searchDocuments}>
                            <i className="fa fa-search" /> Buscar
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderDataTableActions() {
        const { searchBar, selectionList, data, filters } = this.state;

        return (
            <div className="row m-0 m-sm-3 mb-3">
                <div className="col-12 col-md-6 col-lg-4 mb-2 mb-lg-0">
                    <input
                        id="txtSearchInTable"
                        className="form-control"
                        type="text"
                        autoComplete="off"
                        placeholder="Buscar en la tabla"

                        value={searchBar || ""}
                        onChange={({ target: { value } }) => this.searchInTable(value)} />
                </div>

                <div className="col-6 col-md-3 col-lg-2 mb-2 mb-lg-0">
                    {/* i just doing this because CSVLinnk dont have disable prop */}
                    {data.length > 0 ? (
                        <CSVLink
                            className="btn btn-success btn-block"
                            data={data}
                            headers={filters.table !== '' ? headers[filters.table] : headers.default}
                            filename={`${filters.cardCode}_${filters.table}_${filters.dateStart}_${filters.dateEnd}.csv`}>
                            <i className="fa fa-file-excel-o d-lg-none" />
                            <span className="d-none d-lg-inline">Exportar CSV</span>
                        </CSVLink>
                    ) : (
                        <button className="btn btn-success btn-block" disabled>
                            <i className="fa fa-file-excel-o d-lg-none" />
                            <span className="d-none d-lg-inline">Exportar CSV</span>
                        </button>
                    )}
                </div>

                <div className="col-6 col-md-3 col-lg-2 mb-2 mb-lg-0">
                    <button className="btn btn-success btn-print btn-block" disabled={selectionList.length === 0} onClick={this.SendToPrint}> <i className="fa fa-print" /> <span className="d-none d-lg-inline ml-2">Imprimir</span> </button>
                </div>
            </div>
        );
    }

    renderDataTable() {
        const {
            processedData,
            tableNav: {
                pageNumber,
                pageSize,
                firstPage,
                previousPage,
                nextPage,
                lastPage,
            },

            selectedAll,
            selectionList,
        } = this.state;

        const currentHeaders = this.headers.filter(header => !!header.active);
        const paginatedData = paginate(processedData, pageNumber, pageSize);

        return (
            <div className="row ml-0 mx-sm-3" style={{ marginBottom: "4rem" }}>
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0 scrollTableCollect" style={{ maxHeight: "65vh" }}>
                            <table className="table table-striped table-hover m-0" id="dataTableDocuments">
                                <thead className="sticky-headerPOS" style={{ backgroundColor: "white" }}>
                                    <tr key="headers">
                                        <th className="text-center table-check" key="header-selection"> <input id="cbAll" type="checkbox" checked={selectedAll} onChange={() => this.selectAllAction(processedData)} /> </th>
                                        {currentHeaders.map(column => <th className={column.classes} key={`header-${column.field}`}> {column.title} </th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedData.length > 0 ?
                                        paginatedData.map((doc, index) =>
                                            <tr key={`row-${index}`}>
                                                <td className="text-center table-check" key={`row-${index}-selection`}> <input id={`cb-${index}`} type="checkbox" checked={!!selectionList.find(element => element === doc.DocEntry)} onChange={() => this.selectOneAction(doc.DocEntry, processedData)} /></td>
                                                {currentHeaders.map(column => <td className={column.classes} key={`row-${index}-${column.field}`}> {!!column.format ? column.format(doc[column.field], doc) : doc[column.field]} </td>)}
                                            </tr>
                                        )
                                        :
                                        <tr className="text-center" key="no-data">
                                            <td key="no-data-col" colSpan={currentHeaders.length + 1}> No se encontraron resultados </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="card-body text-right p-3" style={{ cursor: "default" }}>
                            {processedData.length > (pageSize || 10) &&
                                <>
                                    <div className="btn page-nav"> {(((pageNumber || 1) - 1) * 10 + 1)} - {((pageNumber || 1) * 10)} de {processedData.length || 0}</div>
                                    <button className="btn btn-nav" disabled={!firstPage} onClick={this.first}> <i className="material-icons">&#xe5dc;</i> </button>
                                    <button className="btn btn-nav" disabled={!previousPage} onClick={this.previous}> <i className="material-icons">&#xe408;</i> </button>
                                    <div className="btn page-nav"> {pageNumber || 0} </div>
                                    <button className="btn btn-nav" disabled={!nextPage} onClick={this.next}> <i className="material-icons">&#xe409;</i> </button>
                                    <button className="btn btn-nav" disabled={!lastPage} onClick={this.last}> <i className="material-icons">&#xe5dd;</i> </button>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            _user,
            filters: { cardName, table },
            showBPSuggestion,
            businessParterSuggestions,
            showSelectBPModal,
            suggestionCatalogs: { businessPartnerCCatalog },

            showPDFViewer,
            docsToPrint,
            printhide,

            sendMailModel,
        } = this.state;

        let inputBPRect = { width: 0, height: 0, top: 0, left: 0, bottom: 0, right: 0 };
        if (this.cardNameInput.current) inputBPRect = this.cardNameInput.current.getBoundingClientRect();

        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        return (
            <div className="content">
                <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1="DOCUMENTOS POR CLIENTE" url1="#" />

                <div className="ml-5">
                    <div className="row ml-0 m-sm-3">
                        <div className="col-12 h3"> Documentos por Cliente </div>
                    </div>
                    {this.renderFilters()}
                    {this.renderDataTableActions()}
                    {this.renderDataTable()}
                </div>

                {showBPSuggestion &&
                    <SuggestionsList
                        suggestions={businessParterSuggestions}
                        keys={[
                            { field: "CardCode", classes: "key", styles: { minWidth: 75, maxWidth: 75 } },
                            { field: "CardName", classes: "", styles: { minWidth: inputBPRect.width - 100, maxWidth: inputBPRect.width - 100 } },
                        ]}
                        action={this.selectBP}
                        styles={{ maxHeight: 200 }}
                        rect={inputBPRect} />
                }

                {showSelectBPModal &&
                    <StandardSelectModal
                        id="selectBPModal"
                        title="Clientes"
                        data={businessPartnerCCatalog}
                        selectAction={this.selectBP}
                        searchBar={cardName}

                        headers={[
                            { title: "Código", value: true, filter: true, field: "CardCode", format: null, classes: "text-left" },
                            { title: "Cliente", value: true, filter: true, field: "CardName", format: null, classes: "text-left" },
                            { title: "RUT", value: false, filter: true, field: "LicTradNum", format: null, classes: "text-left" },
                        ]}

                        actPos="start" />
                }

                {showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={table}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditableDocModel={{}}
                        RefreshDocModel={() => { }}
                        SaveChanges={() => { }}
                        UploadDoc={() => { }}
                        EditParam1={false}
                        OnchangePDfViewer={() => { }}
                        ShowPDFViewer={() => { }}
                        OpenMailModal={this.OpenSendMailModal}
                        MailTools={mailTools}
                        user={_user}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                        reprint={true}
                        time={moment(new Date()).format('HH:mm:ss')}
                        today={moment(new Date()).format('YYYY-MM-DD')}
                        RegisterReprint={() => { }} />
                }
            </div>
        );
    }
    //#endregion
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartnerDocumentsView);
